// Constructor
function YoutubeVideoPlayer(app, $container) {
  this.app = app;
  this.playerID = $container.attr("id");

  this.player = false;
  this.YoutubeReady = false;
  this.playerReady = false;

  this.timeline = false;

  this.init();

  // We need to defer the Youtube API Ready because our functions are wrapped into jQuery ready
  // It is used to catch the callback and trigger it later
  var YTdeferred = $.Deferred();
  window.onYouTubeIframeAPIReady = function () {
    YTdeferred.resolve(window.YT);
  };

  // Call the deffered onYouTubeIframeAPIReady event
  YTdeferred.done($.proxy(this.onYouTubeIframeAPIReady, this));
}

YoutubeVideoPlayer.prototype.init = function () {
  // Load Youtube
  var tag = document.createElement('script');

  tag.src = "https://www.youtube.com/iframe_api";
  var firstScriptTag = document.getElementsByTagName('script')[0];
  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

  $("#video-player-close").off("click").on("click", $.proxy(this.hidePlayer, this));
}

YoutubeVideoPlayer.prototype.onYouTubeIframeAPIReady = function (YT) {
  console.log("Youtube api ready", YT);

  this.YoutubeReady = true;

  if (this.player === false) {
    this.player = new YT.Player(this.playerID, {
      height: '100%',
      width: '100%',
      // videoId: id, // no need to set it because we will load the video seperately
      playerVars: {
        enablejsapi: 1,
        fs: 0, // hide the fullscreen button
        disablekb: 1, // disable keyboard controls
        iv_load_policy: 3, // 3 causes video annotations to not be shown by default
        autoplay: 0,
        loop: 0,
        controls: 0,
        modestbranding: 1,
        rel: 0,
      },
      events: {
        'onReady': $.proxy(this.onPlayerReady(), this),
        'onStateChange': $.proxy(this.onPlayerStateChange, this)
      }
    });
  }
}

YoutubeVideoPlayer.prototype.loadVideo = function (id, callback) {

  if (!this.YoutubeReady || !this.playerReady) {
    console.warn("Youtube and/or player is not ready yet.");
    return;
  }

  console.log(id);
  if (typeof id === "undefined" || id == "") {
    console.warn("Video ID cannot be empty");
    return;
  }

  // Hide main menu
  this.app.hideMenu();

  // this.player.loadVideoById(id); // this always autoplay
  this.player.cueVideoById(id); // this loads without autoplay
}


YoutubeVideoPlayer.prototype.onPlayerReady = function (e) {
  this.playerReady = true;
}

YoutubeVideoPlayer.prototype.onPlayerStateChange = function (e) {

  var playerStatus = e.data;

  console.log("onPlayerStateChange", playerStatus);

  if (playerStatus == -1) { // unstarted

  } else if (playerStatus == 0) { // ended
    this.hidePlayer();

  } else if (playerStatus == 1) { // playing
    // Video started playing
    this.showPlayer();

  } else if (playerStatus == 2) { // paused

  } else if (playerStatus == 3) { // buffering

  } else if (playerStatus == 5) { // video cued
    // Video is ready to be player
    new TweenMax.set($("#video-player-overlay"), {
      autoAlpha: 1
    });

    new TweenMax.set($("#video-player"), {
      autoAlpha: 1
    });

    new TweenMax.set($("#video-player-wrapper"), {
      zIndex: 100000,
      autoAlpha: 1
    });

    this.play();
  }

}

YoutubeVideoPlayer.prototype.showPlayer = function () {
  if (this.timeline != false) {
    this.timeline.kill();
    this.timeline = false;
  }

  this.timeline = new TimelineMax();

  this.timeline.fromTo($("#video-player-overlay"), 1, {
    autoAlpha: 1
  }, {
    autoAlpha: 0
  });

  // Hide main menu
  this.app.hideMenu();

  this.timeline.addCallback(function () {
    $("#video-player-close").addClass("active");
  });
}

YoutubeVideoPlayer.prototype.hidePlayer = function () {
  this.stop();

  $("#video-player-close").removeClass("active");

  if (this.timeline != false) {
    this.timeline.kill();
    this.timeline = false;
  }

  this.timeline = new TimelineMax();

  this.timeline.to($("#video-player"), 1, {
    autoAlpha: 0
  });

  this.timeline.to($("#video-player-wrapper"), 2, {
    autoAlpha: 0
  });

  this.timeline.addCallback(function () {
    new TweenMax.set($("#video-player-wrapper"), {
      zIndex: -10
    });
  });

  // Hide main menu
  this.app.showMenu();

  $(this).trigger("videohidden");
}

YoutubeVideoPlayer.prototype.play = function () {
  this.player.playVideo();
}

YoutubeVideoPlayer.prototype.stop = function () {
  this.player.pauseVideo();
}

// Expose YoutubeVideoPlayer
window.YoutubeVideoPlayer = YoutubeVideoPlayer;
